import { ChangeEvent } from 'react';
import FormGroup from '../../../components/FormGroup';
import Input from '../../../components/Input';
import { GetErrorMessageByFieldNameType } from '../../../hooks/useErrors';
import floatToCurrency from '../../../utils/floatToCurrency';
import { ItensVtEnvelop } from '../types';

interface IItensList {
  getErrorMessageByFieldName: GetErrorMessageByFieldNameType;
  itens: ItensVtEnvelop[];
  handleCorrespondingCodeChange: (e: ChangeEvent<HTMLInputElement>, codItem: number) => void;
  handleCorrespondingCodeConfirmChange: (e: ChangeEvent<HTMLInputElement>, codItem: number) => void;
}

export default function ItensList({
  getErrorMessageByFieldName,
  itens,
  handleCorrespondingCodeChange,
  handleCorrespondingCodeConfirmChange,
}: IItensList) {
  return (
    <>
      {itens.map((item, index) => (
        <div className="dataGroup" key={item.codItem}>
          <div className="title">
            <span>
              {index + 1}:
            </span>

            <div>
              <span>
                Item: {item.descrItemVT} ({floatToCurrency(item.tarifa)})
              </span>

              <span>
                Região: {item.UF} - {item.regiao}
              </span>

              <span>
                Operadora: {item.descrOperadora}
              </span>
            </div>
          </div>
          <div className="aside">
            <div className="loginInput">
              <FormGroup error={getErrorMessageByFieldName(`${item.codItem}`)}>
                <label htmlFor="login">Código correspondente</label>
                <Input
                  placeholder="Ex.: VT-01"
                  value={item.correspondingCode}
                  onChange={(e) => handleCorrespondingCodeChange(e, item.codItem)}
                  autoComplete="new-password"
                  error={getErrorMessageByFieldName(`${item.codItem}`)}
                />
              </FormGroup>
            </div>
            <div className="loginInput">
              <FormGroup error={getErrorMessageByFieldName(`${item.codItem}_confirm`)}>
                <label htmlFor="login">Confirme o código</label>
                <Input
                  placeholder="Ex.: VT-01"
                  value={item.correspondingCodeConfirm}
                  onChange={(e) => handleCorrespondingCodeConfirmChange(e, item.codItem)}
                  autoComplete="new-password"
                  error={getErrorMessageByFieldName(`${item.codItem}_confirm`)}
                />
              </FormGroup>
            </div>
          </div>
        </div>
      ))}
    </>
  );
}
